var React = require('react');

function NewWindow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"style":{"fill":"none","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","stroke":"rgb(45.098039%,46.27451%,50.196078%)","strokeOpacity":"1","strokeMiterlimit":"10"},"d":"M 21 1.998047 L 9 13.998047 M 21 1.998047 L 15 1.998047 M 21 1.998047 L 21 7.998047 M 9 4.998047 L 1.998047 4.998047 L 1.998047 21 L 18 21 L 18 13.998047 ","transform":"matrix(0.666667,0,0,0.666667,0,0)"})));
}

NewWindow.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = NewWindow;

NewWindow.default = NewWindow;
